import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'
import '../src/assets/css/prism.css'
// import Prism from 'prismjs';
// import Prism from '../src/assets/js/prism.js';

import global_var from './api/global_var.js'    //引用文件
Vue.prototype.GLOBAL = global_var   //挂载到Vue实例上面

Vue.config.productionTip = false

Vue.use(ElementUI);
// Vue.use(Prism);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//加入百度统计
router.beforeEach((to, from, next) => {
    // 统计代码
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    next();
});


/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        // window.document.title = to.meta.title
        window.document.title = "编程知识学习"
    }else {
        window.document.title = "编程知识学习"
    }
    next()
})

/*if (to.path) {
    _hmt.push(['_trackPageview', '/#' + to.fullPath]);
}*/
